import React, { useState } from "react";
import { IoWarning } from "react-icons/io5";
import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useParams } from "react-router-dom";
import Handbook from "./Handbook";
import "./pdf-reader.scss";
import Publishing from "./Publishing";
import Template from "./Template";

const JournalDoc= ({ data }) => {
  const params = useParams();
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [errorMsg, setErrorMsg] = useState("");

  function onDocumentLoadSuccess({ numPages }) {
    setTotalPageCount(numPages);
  }

  const prev =() => {
    if (1 < pageNumber) {
      setPageNumber(pageNumber - 1)
    }
  }

  const next = () => {
    if (pageNumber < totalPageCount) {
      setPageNumber(pageNumber + 1)
    }
  }

  return (
    <div className="pdf-reader">
      {errorMsg ?
      <div className="error-msg">
        <IoWarning/>
        &nbsp;
        {errorMsg}
      </div>: null}

      {/* <div className="controls">
        <span className="arrow">
          <FaArrowLeft size={20} onClick={() => prev()}/>
        </span>
        <span className="page-number">{data.page} {pageNumber} / {totalPageCount}</span>
        <span className="arrow">
          <FaArrowRight size={20} onClick={() => next()}/>
        </span>
      </div> */}
      {params.tab === "publishing" ? <Publishing/> : null}
      {params.tab === "template" ? <Template/> : null}
      {params.tab === "handbook" ? <Handbook/> : null}
    </div>
  );
}

export default JournalDoc;